var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSectionio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 40,
    "aria-label": "Section Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logoc",
    d: "M0 39.174h116.87V.437H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.84 27.888l10.95 2.333V9.743L8.84 12.067v15.821zM23.05 34.48L6.215 29.93V10.018l16.81-4.517.024 28.98z",
    fill: "#00A86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.145.622L0 6.478v27.024l16.145 5.857V.622zM2.877 31.915V8.067l10.044-3.1v30.047l-10.044-3.1z",
    fill: "#00A86B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#038754",
    d: "M16.145 10.515l1.593-.337V6.922l-1.593.427zM16.145 32.613l1.593.43v-3.259l-1.593-.34z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.904 18.07c-3.144-.454-3.753-1.185-3.753-2.646 0-1.386 1.065-2.369 3.119-2.369 2.051 0 3.136.79 3.48 2.625l2.966-.801c-.64-2.874-2.887-4.344-6.446-4.344-3.778 0-6.313 2.217-6.313 5.166 0 3.376 2.053 4.686 6.388 5.266 2.942.479 3.779 1.109 3.779 2.772 0 1.663-1.42 2.772-3.423 2.772-3.068 0-3.804-1.512-4.031-3.326h-.01l-3.125.844c.523 2.953 2.643 5.002 7.166 5.002 4.006 0 6.668-2.445 6.668-5.57 0-3.603-2.206-4.812-6.465-5.392M50.681 20.816c.304-2.042 1.546-3.276 3.397-3.276 1.902 0 3.068 1.008 3.22 3.276h-6.617zm3.397-5.493c-3.777 0-6.592 2.72-6.592 6.803v.202c0 4.158 2.815 6.703 6.719 6.703 3.398 0 5.655-1.513 6.085-4.284h-2.966c-.229 1.285-1.192 2.016-3.044 2.016-2.281 0-3.549-1.412-3.65-3.906h9.71v-.882c0-4.712-2.966-6.652-6.262-6.652zM68.506 26.687c-2.257 0-3.677-1.512-3.677-4.384V22.1c0-2.721 1.496-4.334 3.6-4.334 1.623 0 2.79.731 3.043 2.494h2.967c-.355-3.628-3.12-4.938-6.06-4.938-3.702 0-6.693 2.646-6.693 6.829v.2c0 4.209 2.89 6.679 6.693 6.679 3.6 0 5.908-2.142 6.136-5.166H71.7c-.177 1.865-1.571 2.822-3.194 2.822M79.369 24.822v-6.929h2.916V15.6h-2.916v-4.236l-3.068.83V25.1c0 2.494 1.369 3.905 4.006 3.905.938 0 1.597-.15 2.079-.327v-2.42c-.43.177-.888.253-1.496.253-.963 0-1.521-.53-1.521-1.689",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "logod",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logoc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    mask: "url(#logod)",
    d: "M84.719 28.779h3.068V15.6h-3.068zM100.085 22.277c0 2.696-1.37 4.385-3.652 4.385-2.332 0-3.676-1.689-3.676-4.385v-.201c0-2.721 1.394-4.36 3.676-4.36s3.652 1.664 3.652 4.385v.176zm-3.652-6.954c-3.905 0-6.82 2.72-6.82 6.803v.202c0 4.007 2.89 6.703 6.795 6.703 3.904 0 6.82-2.672 6.82-6.779v-.201c0-4.032-2.916-6.728-6.795-6.728zM112.332 15.323c-2.18 0-3.651 1.083-4.285 2.368v-2.09h-3.068v13.178h3.068v-7.762c0-2.09 1.394-3.15 3.118-3.15 1.826 0 2.637.907 2.637 2.899v8.013h3.068v-8.29c0-3.63-1.876-5.166-4.538-5.166M84.719 13.792h3.068v-3.049h-3.068z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionio);
export default __webpack_public_path__ + "static/media/sectionio.3952e7292b1bbe49ed61817ec6320865.svg";
export { ForwardRef as ReactComponent };